export default __webpack_public_path__ + "static/media/Person.dd3d85c3.svg";